import cloneDeep from 'lodash/cloneDeep';

import MapConst from '@/constants/topologymap';

import { isEmpty } from '@/utils/basic';

import { MapInfo } from '@/views/topologymap/js/maps';

export default {
  props: ['objects'],
  data() {
    return {
      MapConst,
      smallField: 'width: 100px;',
      fullField: 'width: 203px;',
      imageField: 'width: 134px; vertical-align: middle;',
      labelField: 'width: calc(100% - 25px);margin-right: 5px;',
      labelCommand: 'text-align: center;',
      formModelDefault: {
        x: undefined,
        y: undefined,
        width: undefined,
        height: undefined,
        r: undefined,
        label: undefined,
        showLabelFlag: undefined,
        showLabelBoxFlag: undefined,
        labelText: undefined,
        labelColor: undefined,
        labelBoxColor: undefined,
        labelSize: undefined,
        labelFont: undefined,
        showEventLabelFlag: undefined,
        customimageName: undefined,
        labelPosition: undefined,
        showRscFlag: undefined,
        showIfEvent: undefined,
        virtualEffectShowFlag: undefined,
        virtualEffectColor: undefined,
        showTrafficLabel: undefined,
        text: undefined,
        customimageId: undefined,
        lineDirection: undefined,
        lineOptions: {
          dashType: undefined,
          arrowType: undefined,
          showIfLabelCheckbox: undefined,
          showIfLabelCombobox: undefined,
        },
        labelOptions: {
          labelSize: undefined,
          labelBold: undefined,
        },
        fillOptions: {
          alpha: undefined,
          color: undefined,
        },
        strokeOptions: {
          alpha: undefined,
          color: undefined,
          weight: undefined,
        },
        styleOptions: {
          showImportance: undefined,
          showNormalColor: undefined,
          imageType: undefined,
        },
        objIds: [],
        linkMode: undefined,
      },
      formModel: {},
    };
  },
  watch: {
    objects: {
      handler(newValue) {
        if (isEmpty(newValue)) {
          return;
        }
        this.restoreFormModel();
      },
      immediate: true,
    },
  },
  created() {
    this.restoreFormModel();
  },
  mounted() {
    this.addWatcher();
  },
  methods: {
    /**
     * Form 데이터 변경을 감지하도록 설정한다.
     * @author KangBonghun(toto1323)
     */
    addWatcher() {
      Object.keys(this.formModel).forEach((property) => {
        const value = this.formModel[property];

        if (value && !Array.isArray(value) && typeof value === 'object' && Object.keys(value).length > 0) {
          Object.keys(value).forEach((subProperty) => {
            const key = `${property}.${subProperty}`;
            this.$watch(`formModel.${key}`, (newVal, oldVal) => this.formWatch(key, newVal, oldVal));
          });
        } else {
          const key = property;
          this.$watch(`formModel.${key}`, (newVal, oldVal) => this.formWatch(key, newVal, oldVal));
        }
      });
    },
    removeWatcher() {},
    /**
     * Form 데이터가 변경되면 선택 된 오브젝트에 변경 된 속성값을 반영한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} key    [description]
     * @param  {[type]} newVal [description]
     * @param  {[type]} oldVal [description]
     * @return {[type]}        [description]
     */
    formWatch(key, newVal) {
      // 사용자 정의 위젯에서 관리대상 다 빼면 이 부분에서 튕겨져나가고, Model의 isChanged 값이 안바뀌기 때문에 DB에 저장이 안된다. 따라서, 주석처리함. (관련 결함 : #47794)
      // if (isEmpty(newVal)) {
      //   return;
      // }

      const elements = [];

      this.objects.forEach((object) => {
        if (object.get(key) !== newVal) {
          elements.push({
            element: object,
            property: key,
            value: object.get(key),
          });
        }

        object.set(key, newVal);
      });

      if (elements.length > 0) {
        MapInfo.getInstance(this).addEditHistory({
          type: MapConst.HISTORY_TYPE.PROPERTY,
          elements,
        });
      }
    },
    /**
     * 선택 된 오브젝트에 따라 Form 데이터를 복원한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    restoreFormModel() {
      if (this.objects.length === 1) {
        const object = this.objects[0];
        this.formModel = cloneDeep(object.get('model'));
      } else {
        this.formModel = cloneDeep(this.formModelDefault);
      }
    },
    /**
     * 레이블 구분자 선택
     * @author KangBonghun(toto1323)
     * @param  {[type]} command 구분자
     */
    onCommandClick(command) {
      this.formModel.label = (this.formModel.label || '') + command;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/topologymap/object-property.js